<!--<sub>Measurement</sub>-->
<div >
  {{line.variable.text}}
  {{ GetValue( itemValue) }}
  <app-unit [unit]="line.variable.unit"></app-unit>
</div>





